import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 362,
	height: 183,
	fill: "none",
	viewBox: "0 0 362 183",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#4F000E",
			stroke: "#fff",
			strokeWidth: 2.3,
			d: "M337.7 97v79.6c0 2.5-2 4.6-4.6 4.6H23.4c-2.5 0-4.5-2-4.5-4.6v-76.5c0-2.6 2-4.6 4.5-4.6h161.4c1.3 0 2.5-.6 3.4-1.5L266 8.2c1.9-2.1 5.3-2 7 .3l63.8 85.8c.6.8.9 1.7.9 2.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#F0F4FA",
			strokeWidth: 1.1,
			d: "M36 102.3v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.8-77.8v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.7-77.8v77.8m13.2-78.9v78.9M200 92v88m13.7-99.4v99.5m13.7-122.3V180m13.7-139.4v139.5m13.7-150.9v150.9m13.8-162.3V180m13.7-150.8v150.9M296 49.8V180m13.7-109.7v109.8m13.7-91.5v91.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m264.6 8.6 78 95.2c.3.5 1 .8 1.7.8h11.9c2 0 3-2.2 1.7-3.7L274.3 2c-.7-.9-1.9-1-2.8-.5L265.2 5a2.3 2.3 0 0 0-.6 3.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4F000E",
			d: "m265.2 13 72.4 88.5c.4.5 1 .8 1.7.8H350c2 0 3-2.2 1.8-3.7L272.7 5c-1-1-2.7-1-3.6 0l-4 5c-.6.9-.6 2 0 3Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-26-inside-1_11964_14641",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("path", { d: "M244.6 112.6c0-1.2 1-2.3 2.2-2.3h46.9c1.3 0 2.3 1 2.3 2.3v68.6h-51.4v-68.6Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#4F000E",
			stroke: "#fff",
			strokeWidth: 6.9,
			d: "M244.6 112.6c0-1.2 1-2.3 2.2-2.3h46.9c1.3 0 2.3 1 2.3 2.3v68.6h-51.4v-68.6Z",
			mask: "url(#path-26-inside-1_11964_14641)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#39000B",
			fillOpacity: .8,
			d: "M236.5 40.7c-9.3 6.5-26 24.2-32.5 31.4a1064 1064 0 0 1-21.5 22 3.6 3.6 0 0 0 4.6 5.6l7.1-4.8 12-10.3.9-1 6.1-9.5.8-.9L227.7 61c.3-.2.6-.5.8-.9l6.8-10.1.7-.9 12.8-11.3c.3-.2.6-.6.8-1l5.8-9 1-1 9-7.3 1-1 4.3-6.6c1.3-2 .7-4.7-1.7-5a16 16 0 0 0-7 1.5c-11 4.8.9 7.8-8.8 14-9.8 6.3-7.3 11.7-16.7 18.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#39000B",
			fillOpacity: .8,
			d: "M127.1 98.6a417 417 0 0 0-54.8-3c-7.1 0-29.3 4-41.8 6.5-2 .3-2 3.2 0 3.6h.7l12-1.8h1.1l18.8 1.8h1l14.1-1.9h1l22.8 2h1l15-2h1l21 2 1-.1 13.5-1.8h1.2l14.4 1.8h1.2l10.4-1.3c2.5-.4 4-2.7 2.3-4.5a18 18 0 0 0-6.9-4.2c-13.4-5-6.4 5.9-19.9 2.9-13.6-3.1-16.4 2.5-30 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m186.8 98.2 85.8-97-169 14.8a45.7 45.7 0 0 0-27.8 12.7L6.2 96.4c-2.3 2.1-.7 5.9 2.4 5.8l174-2.1c1.6 0 3.1-.7 4.2-2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C3D0E6",
			fillOpacity: .3,
			d: "M120.5 89.4a515 515 0 0 0-60.9-2.9c-7.9 0-32.4 4-46.3 6.4-2 .4-2 3.3 0 3.7h.6l13.5-1.9h1l21.2 1.9h1l15.7-2h1l25.4 2h.9l17-2h.8l23.6 2h1l15-2h1.2l16.2 2h1l12.2-1.4c2.6-.3 4-2.7 2.2-4.5-1.5-1.4-4-3-7.7-4.2-14.9-5-7.1 6-22 3-15.2-3.1-18.4 2.4-33.6 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: 3.4,
			d: "m247.1 111.6 48 68.6m-49.9.7 48-67.1"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-33-inside-2_11964_14641",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 27,
				height: 32.8,
				x: 40.1,
				y: 116.6,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 32.8,
			x: 40.1,
			y: 116.6,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 5.8,
			mask: "url(#path-33-inside-2_11964_14641)",
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: 2.9,
			d: "M54.1 147.5v-28m10.2 14H41.1"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-36-inside-3_11964_14641",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 27,
				height: 32.8,
				x: 91.1,
				y: 116.6,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 32.8,
			x: 91.1,
			y: 116.6,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 5.8,
			mask: "url(#path-36-inside-3_11964_14641)",
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: 2.9,
			d: "M105.1 147.5v-28m10.1 14H92.1"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-39-inside-4_11964_14641",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 27,
				height: 32.8,
				x: 142.1,
				y: 116.6,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 32.8,
			x: 142.1,
			y: 116.6,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 5.8,
			mask: "url(#path-39-inside-4_11964_14641)",
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: 2.9,
			d: "M155.2 147.5v-28m11.1 14h-23.2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 259.3,
			cy: 131.4,
			r: 1.8,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 259.1,
			cy: 128.4,
			r: 2.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 259.3,
			cy: 125.5,
			r: 2.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 260.6,
			cy: 122.7,
			r: 1.8,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 262.7,
			cy: 120.4,
			r: 2.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 265.6,
			cy: 119,
			r: 2.1,
			fill: "#0F7166"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 283 129.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 283.4 126.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 283.3 123.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 281.6 121)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 279.9 118.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(-1 0 0 1 277 116.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#0F7166",
			transform: "matrix(-.79 .614 .614 .79 274.6 116)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "scale(-1 1) rotate(37.9 -303.2 -338)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "scale(-1 1) rotate(37.9 -302.7 -333)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 257.5 129.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 257 133.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 257.2 136.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 258.9 138.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 260.6 141.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.1,
			cy: 2.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "matrix(1 0 0 -1 263.5 142.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 281.2,
			cy: 128,
			r: 1.8,
			fill: "#0F7166",
			transform: "rotate(180 281.2 128)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 281.3,
			cy: 131.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "rotate(180 281.3 131)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 281.1,
			cy: 134,
			r: 2.1,
			fill: "#0F7166",
			transform: "rotate(180 281.1 134)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 279.8,
			cy: 136.7,
			r: 1.8,
			fill: "#0F7166",
			transform: "rotate(180 279.8 136.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 277.7,
			cy: 139.1,
			r: 2.1,
			fill: "#0F7166",
			transform: "rotate(180 277.7 139.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 274.8,
			cy: 140.5,
			r: 2.1,
			fill: "#0F7166",
			transform: "rotate(180 274.8 140.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 271.3,
			cy: 141.5,
			r: 2.1,
			fill: "#0F7166",
			transform: "rotate(-142 271.3 141.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 268.2,
			cy: 140.8,
			r: 2.1,
			fill: "#0F7166",
			transform: "rotate(-142 268.2 140.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 270.2,
			cy: 129.4,
			r: 8.5,
			stroke: "#0F7166",
			strokeWidth: 6.3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 276.5,
			cy: 124.6,
			r: 1.8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 263.5,
			cy: 135,
			r: 1.8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 260.3,
			cy: 125.6,
			r: 1.8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 266,
			cy: 120.9,
			r: 1.1,
			fill: "red"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 278,
			cy: 134.4,
			r: 1.1,
			fill: "red"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			fillRule: "evenodd",
			d: "M270.6 144.7c-2.9-.1-8.4-1.2-7.3-4.4 1-3.3 3.3-2.4 4.3-1.6 1 .7 3 3 3 6Zm-1-1c-1.5 0-4-.5-3.5-2.3.4-1 1.7-.4 1.9-.3.6.5 1.2 1.2 1.7 2.6Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			fillRule: "evenodd",
			d: "M270 144.6c1-2.8 3.9-8 6.4-5.8 2.5 2.2 1 4.2 0 4.9a7 7 0 0 1-6.4 1Zm1.1-.6c.5-1.4 2.5-3.4 3.5-2.8 1.1.7.4 1.8-.1 2.2a4 4 0 0 1-3.4.6Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			d: "M268.4 148a5 5 0 0 1 2.5-3.5l-.8-.4c-1.9.5-2.6 1.2-3.7 2.7h1.6l.4 1.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			d: "M272.6 148a5 5 0 0 0-2.6-3.4l.9-.5a6 6 0 0 1 3.6 2.8H273l-.4 1.1Z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 18.5,
					cy: 105.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 26.2,
					cy: 104.4,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 22,
					cy: 104,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 23.5,
					cy: 107,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 28.5,
					cy: 106.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 31.5,
					cy: 104.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 39.2,
					cy: 105.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 35.7,
					cy: 104,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 35,
					cy: 107,
					r: 1.1,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 42.2,
					cy: 103.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 44.5,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 52.2,
					cy: 104.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 47.9,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 49.5,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 54.4,
					cy: 106.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57.5,
					cy: 104.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 65.1,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 61.7,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 60.9,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 68.2,
					cy: 103.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 69.7,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77.4,
					cy: 104.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 73.2,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 74.7,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 95,
					cy: 105.9,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 98.4,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 99.9,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 79.7,
					cy: 106.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 82.7,
					cy: 104.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 90.4,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 86.9,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 86.2,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 93.4,
					cy: 103.6,
					r: .8,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 18.5,
					cy: 105.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 26.2,
					cy: 104.4,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 22,
					cy: 104,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 23.5,
					cy: 107,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 28.5,
					cy: 106.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 31.5,
					cy: 104.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 39.2,
					cy: 105.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 35.7,
					cy: 104,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 35,
					cy: 107,
					r: 1.1,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 42.2,
					cy: 103.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 44.5,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 52.2,
					cy: 104.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 47.9,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 49.5,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 54.4,
					cy: 106.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57.5,
					cy: 104.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 65.1,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 61.7,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 60.9,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 68.2,
					cy: 103.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 69.7,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 77.4,
					cy: 104.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 73.2,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 74.7,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 95,
					cy: 105.9,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 98.4,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 99.9,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 79.7,
					cy: 106.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 82.7,
					cy: 104.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 90.4,
					cy: 105.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 86.9,
					cy: 104,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 86.2,
					cy: 107,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 93.4,
					cy: 103.6,
					r: .8,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.5,
			cy: 105.9,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 26.2,
			cy: 104.4,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 22,
			cy: 104,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 23.5,
			cy: 107,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.5,
			cy: 106.6,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 31.5,
			cy: 104.4,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39.2,
			cy: 105.9,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35.7,
			cy: 104,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35,
			cy: 107,
			r: 1.1,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 42.2,
			cy: 103.6,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.5,
			cy: 105.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 52.2,
			cy: 104.4,
			r: 1.5,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 47.9,
			cy: 104,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 49.5,
			cy: 107,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 54.4,
			cy: 106.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 57.5,
			cy: 104.4,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 65.1,
			cy: 105.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 61.7,
			cy: 104,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 60.9,
			cy: 107,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 68.2,
			cy: 103.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 69.7,
			cy: 105.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 77.4,
			cy: 104.4,
			r: 1.5,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 73.2,
			cy: 104,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 74.7,
			cy: 107,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 95,
			cy: 105.9,
			r: 1.5,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 98.4,
			cy: 104,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 99.9,
			cy: 107,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 79.7,
			cy: 106.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 82.7,
			cy: 104.4,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 90.4,
			cy: 105.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 86.9,
			cy: 104,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 86.2,
			cy: 107,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 93.4,
			cy: 103.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 101.5,
					cy: 104.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 109.1,
					cy: 103.4,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 104.9,
					cy: 103,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 106.4,
					cy: 106,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 111.4,
					cy: 105.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 114.5,
					cy: 103.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 122.1,
					cy: 104.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 118.7,
					cy: 103,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 117.9,
					cy: 106,
					r: 1.1,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 125.2,
					cy: 102.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 127.5,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 135.1,
					cy: 103.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 130.9,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 132.4,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 137.4,
					cy: 105.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.4,
					cy: 103.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 148.1,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 144.6,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 143.9,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 151.1,
					cy: 102.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 152.7,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 160.3,
					cy: 103.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 156.1,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 157.6,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 177.9,
					cy: 104.9,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 181.3,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 182.8,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 162.6,
					cy: 105.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 165.7,
					cy: 103.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 173.3,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 169.9,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 169.1,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 176.4,
					cy: 102.6,
					r: .8,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 101.5,
					cy: 104.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 109.1,
					cy: 103.4,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 104.9,
					cy: 103,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 106.4,
					cy: 106,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 111.4,
					cy: 105.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 114.5,
					cy: 103.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 122.1,
					cy: 104.9,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 118.7,
					cy: 103,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 117.9,
					cy: 106,
					r: 1.1,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 125.2,
					cy: 102.6,
					r: .8,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 127.5,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 135.1,
					cy: 103.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 130.9,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 132.4,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 137.4,
					cy: 105.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 140.4,
					cy: 103.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 148.1,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 144.6,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 143.9,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 151.1,
					cy: 102.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 152.7,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 160.3,
					cy: 103.4,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 156.1,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 157.6,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 177.9,
					cy: 104.9,
					r: 1.5,
					fill: "#FFF4E0"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 181.3,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 182.8,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 162.6,
					cy: 105.6,
					r: .8,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 165.7,
					cy: 103.4,
					r: 1.5,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 173.3,
					cy: 104.9,
					r: 1.5,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 169.9,
					cy: 103,
					r: 1.1,
					fill: "#FDC564"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 169.1,
					cy: 106,
					r: 1.1,
					fill: "#FFDFA2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 176.4,
					cy: 102.6,
					r: .8,
					fill: "#FDC564"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 101.5,
			cy: 104.9,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 109.1,
			cy: 103.4,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 104.9,
			cy: 103,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106.4,
			cy: 106,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 111.4,
			cy: 105.6,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 114.5,
			cy: 103.4,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 122.1,
			cy: 104.9,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 118.7,
			cy: 103,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 117.9,
			cy: 106,
			r: 1.1,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 125.2,
			cy: 102.6,
			r: .8,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 127.5,
			cy: 104.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 135.1,
			cy: 103.4,
			r: 1.5,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 130.9,
			cy: 103,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 132.4,
			cy: 106,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 137.4,
			cy: 105.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 140.4,
			cy: 103.4,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 148.1,
			cy: 104.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 144.6,
			cy: 103,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 143.9,
			cy: 106,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 151.1,
			cy: 102.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 152.7,
			cy: 104.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 160.3,
			cy: 103.4,
			r: 1.5,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 156.1,
			cy: 103,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 157.6,
			cy: 106,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177.9,
			cy: 104.9,
			r: 1.5,
			fill: "#FFF4E0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 181.3,
			cy: 103,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 182.8,
			cy: 106,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 162.6,
			cy: 105.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 165.7,
			cy: 103.4,
			r: 1.5,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 173.3,
			cy: 104.9,
			r: 1.5,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 169.9,
			cy: 103,
			r: 1.1,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 169.1,
			cy: 106,
			r: 1.1,
			fill: "#FFDFA2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 176.4,
			cy: 102.6,
			r: .8,
			fill: "#FDC564"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter4_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 185.8,
					cy: 106.5,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 185.8 106.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 189.7,
					cy: 99.7,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 189.7 99.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 186.7,
					cy: 102.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 186.7 102.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 190,
					cy: 103.5,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 190 103.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 192.9,
					cy: 99.5,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 193 99.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 193.2,
					cy: 95.7,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 193.2 95.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 199.4,
					cy: 91,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 199.4 91)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 195.7,
					cy: 92.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 195.7 92.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 197.5,
					cy: 94.9,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 197.5 94.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 199.7,
					cy: 87.1,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 199.7 87.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 202.9,
					cy: 86.9,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 203 87)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 206.8,
					cy: 80.2,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 206.8 80.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 203.8,
					cy: 83.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 203.8 83)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 207.1,
					cy: 83.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 207 84)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 210.1,
					cy: 80,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 210 80)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 210.4,
					cy: 76.1,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 210.4 76.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 216.5,
					cy: 71.4,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 216.5 71.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 212.8,
					cy: 72.7,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 212.8 72.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 214.6,
					cy: 75.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 214.6 75.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 216.8,
					cy: 67.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 216.8 67.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 219.6,
					cy: 68,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 219.6 68)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 223.4,
					cy: 61.2,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 223.4 61.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 220.4,
					cy: 64.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 220.4 64.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 223.7,
					cy: 65,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 223.7 65)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 236.2,
					cy: 49,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 236.2 49)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 237,
					cy: 45.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 237 45.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240.3,
					cy: 46,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 240.3 46)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 226.7,
					cy: 61,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 226.7 61)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 227,
					cy: 57.2,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 227 57.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 233.2,
					cy: 52.4,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 233.2 52.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 229.5,
					cy: 53.8,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 229.5 53.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 231.3,
					cy: 56.4,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 231.3 56.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 233.5,
					cy: 48.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 233.5 48.6)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter5_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 185.8,
					cy: 106.5,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 185.8 106.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 189.7,
					cy: 99.7,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 189.7 99.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 186.7,
					cy: 102.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 186.7 102.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 190,
					cy: 103.5,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 190 103.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 192.9,
					cy: 99.5,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 193 99.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 193.2,
					cy: 95.7,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 193.2 95.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 199.4,
					cy: 91,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 199.4 91)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 195.7,
					cy: 92.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 195.7 92.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 197.5,
					cy: 94.9,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 197.5 94.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 199.7,
					cy: 87.1,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 199.7 87.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 202.9,
					cy: 86.9,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 203 87)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 206.8,
					cy: 80.2,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 206.8 80.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 203.8,
					cy: 83.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 203.8 83)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 207.1,
					cy: 83.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 207 84)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 210.1,
					cy: 80,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 210 80)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 210.4,
					cy: 76.1,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 210.4 76.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 216.5,
					cy: 71.4,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 216.5 71.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 212.8,
					cy: 72.7,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 212.8 72.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 214.6,
					cy: 75.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 214.6 75.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 216.8,
					cy: 67.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 216.8 67.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 219.6,
					cy: 68,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 219.6 68)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 223.4,
					cy: 61.2,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 223.4 61.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 220.4,
					cy: 64.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 220.4 64.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 223.7,
					cy: 65,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 223.7 65)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 236.2,
					cy: 49,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 236.2 49)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 237,
					cy: 45.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 237 45.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 240.3,
					cy: 46,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 240.3 46)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 226.7,
					cy: 61,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 226.7 61)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 227,
					cy: 57.2,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 227 57.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 233.2,
					cy: 52.4,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 233.2 52.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 229.5,
					cy: 53.8,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 229.5 53.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 231.3,
					cy: 56.4,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 231.3 56.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 233.5,
					cy: 48.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 233.5 48.6)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 185.8,
			cy: 106.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(-48.8 185.8 106.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 189.7,
			cy: 99.7,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 189.7 99.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 186.7,
			cy: 102.6,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 186.7 102.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 190,
			cy: 103.5,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 190 103.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 192.9,
			cy: 99.5,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 193 99.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 193.2,
			cy: 95.7,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(-48.8 193.2 95.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 199.4,
			cy: 91,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(-48.8 199.4 91)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 195.7,
			cy: 92.3,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 195.7 92.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 197.5,
			cy: 94.9,
			r: 1.1,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 197.5 94.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 199.7,
			cy: 87.1,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 199.7 87.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 202.9,
			cy: 86.9,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 203 87)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 206.8,
			cy: 80.2,
			r: 1.5,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 206.8 80.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 203.8,
			cy: 83.1,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 203.8 83)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 207.1,
			cy: 83.9,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 207 84)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 210.1,
			cy: 80,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 210 80)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 210.4,
			cy: 76.2,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(-48.8 210.4 76.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 216.5,
			cy: 71.4,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 216.5 71.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 212.8,
			cy: 72.7,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 212.8 72.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 214.6,
			cy: 75.3,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 214.6 75.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 216.8,
			cy: 67.6,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 216.8 67.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 219.6,
			cy: 68,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 219.6 68)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 223.4,
			cy: 61.2,
			r: 1.5,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 223.4 61.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 220.4,
			cy: 64.1,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 220.4 64.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 223.7,
			cy: 65,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 223.7 65)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 236.2,
			cy: 49,
			r: 1.5,
			fill: "#FFF4E0",
			transform: "rotate(-48.8 236.2 49)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 237,
			cy: 45.1,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 237 45.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 240.3,
			cy: 46,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 240.3 46)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 226.7,
			cy: 61,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 226.7 61)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 227,
			cy: 57.2,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(-48.8 227 57.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 233.2,
			cy: 52.4,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 233.2 52.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 229.5,
			cy: 53.8,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 229.5 53.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231.3,
			cy: 56.4,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 231.3 56.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 233.5,
			cy: 48.6,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(-48.8 233.5 48.6)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter6_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 242.2,
					cy: 41.1,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 242.2 41.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 246.1,
					cy: 34.3,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 246 34.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 243,
					cy: 37.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 243 37.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 246.3,
					cy: 38.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 246.3 38.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 249.3,
					cy: 34.1,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 249.3 34.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 249.6,
					cy: 30.3,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 249.6 30.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 255.8,
					cy: 25.6,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 255.8 25.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 252.1,
					cy: 26.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 252 26.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 253.9,
					cy: 29.5,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 253.9 29.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 256.1,
					cy: 21.8,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 256 21.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 259.3,
					cy: 21.6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 259.3 21.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 263.2,
					cy: 14.8,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 263.2 14.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.1,
					cy: 17.7,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 260.1 17.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 263.4,
					cy: 18.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 263.4 18.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 266.4,
					cy: 14.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 266.4 14.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 266.7,
					cy: 10.8,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 266.7 10.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 272.9,
					cy: 6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 272.9 6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 269.2,
					cy: 7.4,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 269.2 7.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 271,
					cy: 9.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 271 10)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter7_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 242.2,
					cy: 41.1,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 242.2 41.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 246.1,
					cy: 34.3,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 246 34.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 243,
					cy: 37.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 243 37.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 246.3,
					cy: 38.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 246.3 38.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 249.3,
					cy: 34.1,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 249.3 34.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 249.6,
					cy: 30.3,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 249.6 30.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 255.8,
					cy: 25.6,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 255.8 25.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 252.1,
					cy: 26.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 252 26.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 253.9,
					cy: 29.5,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 253.9 29.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 256.1,
					cy: 21.8,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 256 21.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 259.3,
					cy: 21.6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 259.3 21.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 263.2,
					cy: 14.8,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(-48.8 263.2 14.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.1,
					cy: 17.7,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 260.1 17.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 263.4,
					cy: 18.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 263.4 18.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 266.4,
					cy: 14.6,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(-48.8 266.4 14.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 266.7,
					cy: 10.8,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(-48.8 266.7 10.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 269.2,
					cy: 7.4,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(-48.8 269.2 7.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 271,
					cy: 9.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(-48.8 271 10)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 266.7,
			cy: 10.8,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(-48.8 266.7 10.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 269.2,
			cy: 7.4,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(-48.8 269.2 7.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 271,
			cy: 9.9,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(-48.8 271 10)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter8_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 272.7,
					cy: 9.6,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 272.7 9.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 278.8,
					cy: 14.5,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 278.8 14.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 276.4,
					cy: 11,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 276.4 11)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 275,
					cy: 14.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 275 14.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 278.5,
					cy: 17.7,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 278.5 17.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 282.2,
					cy: 18.6,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 282.2 18.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 285.8,
					cy: 25.5,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 285.8 25.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 285.1,
					cy: 21.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 285.1 21.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 282.3,
					cy: 23,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(50.6 282.3 23)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 289.6,
					cy: 26.4,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 289.6 26.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 289.2,
					cy: 29.6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 289.2 29.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 295.3,
					cy: 34.6,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 295.3 34.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 292.9,
					cy: 31.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 292.9 31)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 291.5,
					cy: 34.2,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 291.5 34.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 294.9,
					cy: 37.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 295 37.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 298.7,
					cy: 38.7,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 298.7 38.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 302.3,
					cy: 45.6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 302.3 45.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 301.6,
					cy: 41.7,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 301.6 41.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 298.8,
					cy: 43.1,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 298.8 43)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 306,
					cy: 46.5,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 306 46.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 305.2,
					cy: 49.1,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 305.2 49.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 311.3,
					cy: 54.1,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 311.3 54)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 308.9,
					cy: 50.6,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 308.9 50.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 307.5,
					cy: 53.7,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 307.5 53.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 321.2,
					cy: 68.6,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 321.2 68.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 324.9,
					cy: 70.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 324.9 70)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 323.5,
					cy: 73.2,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 323.5 73.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 311,
					cy: 57.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 311 57.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 314.7,
					cy: 58.2,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 314.7 58.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 318.3,
					cy: 65.1,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 318.3 65)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 317.6,
					cy: 61.2,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 317.6 61.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 314.8,
					cy: 62.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 314.8 62.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 322,
					cy: 66,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 322 66)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter9_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 272.7,
					cy: 9.6,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 272.7 9.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 278.8,
					cy: 14.5,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 278.8 14.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 276.4,
					cy: 11,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 276.4 11)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 275,
					cy: 14.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 275 14.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 278.5,
					cy: 17.7,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 278.5 17.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 282.2,
					cy: 18.6,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 282.2 18.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 285.8,
					cy: 25.5,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 285.8 25.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 285.1,
					cy: 21.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 285.1 21.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 282.3,
					cy: 23,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(50.6 282.3 23)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 289.6,
					cy: 26.4,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 289.6 26.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 289.2,
					cy: 29.6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 289.2 29.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 295.3,
					cy: 34.6,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 295.3 34.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 292.9,
					cy: 31.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 292.9 31)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 291.5,
					cy: 34.2,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 291.5 34.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 294.9,
					cy: 37.8,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 295 37.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 298.7,
					cy: 38.7,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 298.7 38.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 302.3,
					cy: 45.6,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 302.3 45.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 301.6,
					cy: 41.7,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 301.6 41.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 298.8,
					cy: 43.1,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 298.8 43)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 306,
					cy: 46.5,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 306 46.5)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 305.2,
					cy: 49.1,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 305.2 49.1)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 311.3,
					cy: 54.1,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 311.3 54)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 308.9,
					cy: 50.6,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 308.9 50.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 307.5,
					cy: 53.7,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 307.5 53.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 321.2,
					cy: 68.6,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 321.2 68.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 324.9,
					cy: 70.1,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 324.9 70)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 323.5,
					cy: 73.2,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 323.5 73.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 311,
					cy: 57.3,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 311 57.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 314.7,
					cy: 58.2,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 314.7 58.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 318.3,
					cy: 65.1,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 318.3 65)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 317.6,
					cy: 61.2,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 317.6 61.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 314.8,
					cy: 62.6,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 314.8 62.6)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 322,
					cy: 66,
					r: .8,
					fill: "#FDC564",
					transform: "rotate(50.6 322 66)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 272.7,
			cy: 9.6,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(50.6 272.7 9.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 278.8,
			cy: 14.5,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 278.8 14.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 276.4,
			cy: 11,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 276.4 11)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 275,
			cy: 14.1,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(50.6 275 14.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 278.5,
			cy: 17.7,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(50.6 278.5 17.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 282.2,
			cy: 18.6,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(50.6 282.2 18.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 285.8,
			cy: 25.5,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(50.6 285.8 25.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 285.1,
			cy: 21.6,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 285.1 21.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 282.3,
			cy: 23,
			r: 1.1,
			fill: "#FFF4E0",
			transform: "rotate(50.6 282.3 23)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 289.5,
			cy: 26.4,
			r: .8,
			fill: "#FFF4E0",
			transform: "rotate(50.6 289.5 26.4)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 289.2,
			cy: 29.6,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 289.2 29.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 295.3,
			cy: 34.6,
			r: 1.5,
			fill: "#FFF4E0",
			transform: "rotate(50.6 295.3 34.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 292.9,
			cy: 31.1,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(50.6 292.9 31)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 291.5,
			cy: 34.2,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 291.5 34.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 295,
			cy: 37.8,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 295 37.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 298.7,
			cy: 38.7,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(50.6 298.7 38.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 302.3,
			cy: 45.6,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 302.3 45.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 301.6,
			cy: 41.7,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(50.6 301.6 41.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 298.8,
			cy: 43.1,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 298.8 43)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 306,
			cy: 46.5,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 306 46.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 305.2,
			cy: 49.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 305.2 49.1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 311.3,
			cy: 54.1,
			r: 1.5,
			fill: "#FFF4E0",
			transform: "rotate(50.6 311.3 54)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 308.9,
			cy: 50.6,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(50.6 308.9 50.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 307.5,
			cy: 53.7,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 307.5 53.7)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 321.3,
			cy: 68.6,
			r: 1.5,
			fill: "#FFF4E0",
			transform: "rotate(50.6 321.3 68.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 324.9,
			cy: 70.1,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(50.6 325 70)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 323.5,
			cy: 73.2,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 323.5 73.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 311,
			cy: 57.3,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 311 57.3)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 314.7,
			cy: 58.2,
			r: 1.5,
			fill: "#FDC564",
			transform: "rotate(50.6 314.7 58.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 318.3,
			cy: 65.1,
			r: 1.5,
			fill: "#FFDFA2",
			transform: "rotate(50.6 318.3 65)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 317.6,
			cy: 61.2,
			r: 1.1,
			fill: "#FDC564",
			transform: "rotate(50.6 317.6 61.2)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 314.8,
			cy: 62.6,
			r: 1.1,
			fill: "#FFDFA2",
			transform: "rotate(50.6 314.8 62.6)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 322.1,
			cy: 66,
			r: .8,
			fill: "#FDC564",
			transform: "rotate(50.6 322 66)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter10_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 328.1,
					cy: 75.8,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 328 75.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 334.1,
					cy: 80.8,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 334 80.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 331.7,
					cy: 77.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 331.7 77.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 330.3,
					cy: 80.4,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 330.3 80.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 333.8,
					cy: 84,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 333.8 84)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 337.5,
					cy: 84.9,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 337.5 84.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 341.2,
					cy: 91.8,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 341.2 91.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 340.5,
					cy: 87.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 340.5 87.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 337.6,
					cy: 89.2,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(50.6 337.6 89.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 344.9,
					cy: 92.7,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 344.9 92.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 344.6,
					cy: 95.9,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 344.6 95.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 350.6,
					cy: 100.8,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 350.6 100.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 348.2,
					cy: 97.3,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 348.2 97.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 346.8,
					cy: 100.5,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 346.8 100.5)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter11_f_11964_14641)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 328.1,
					cy: 75.8,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 328 75.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 334.1,
					cy: 80.8,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 334 80.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 331.7,
					cy: 77.3,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 331.7 77.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 330.3,
					cy: 80.4,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 330.3 80.4)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 333.8,
					cy: 84,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 333.8 84)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 337.5,
					cy: 84.9,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 337.5 84.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 341.2,
					cy: 91.8,
					r: 1.5,
					fill: "#FDC564",
					transform: "rotate(50.6 341.2 91.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 340.5,
					cy: 87.9,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 340.5 87.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 337.6,
					cy: 89.2,
					r: 1.1,
					fill: "#FFF4E0",
					transform: "rotate(50.6 337.6 89.2)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 344.9,
					cy: 92.7,
					r: .8,
					fill: "#FFF4E0",
					transform: "rotate(50.6 344.9 92.7)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 344.6,
					cy: 95.9,
					r: 1.5,
					fill: "#FFDFA2",
					transform: "rotate(50.6 344.6 95.9)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 350.6,
					cy: 100.8,
					r: 1.5,
					fill: "#FFF4E0",
					transform: "rotate(50.6 350.6 100.8)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 348.2,
					cy: 97.3,
					r: 1.1,
					fill: "#FDC564",
					transform: "rotate(50.6 348.2 97.3)"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 346.8,
					cy: 100.5,
					r: 1.1,
					fill: "#FFDFA2",
					transform: "rotate(50.6 346.8 100.5)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-545-inside-5_11964_14641",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 27,
				height: 32.8,
				x: 256.1,
				y: 52.6,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 27,
			height: 32.8,
			x: 256.1,
			y: 52.6,
			fill: "#FFDFA3",
			stroke: "#fff",
			strokeWidth: 5.8,
			mask: "url(#path-545-inside-5_11964_14641)",
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeWidth: 2.9,
			d: "M269.2 83.5v-28m11.1 14h-23.2"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_11964_14641",
				width: 87.1,
				height: 8.4,
				x: 15.5,
				y: 101.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_f_11964_14641",
				width: 87.1,
				height: 8.4,
				x: 15.5,
				y: 101.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_f_11964_14641",
				width: 87.1,
				height: 8.4,
				x: 98.4,
				y: 100.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_f_11964_14641",
				width: 87.1,
				height: 8.4,
				x: 98.4,
				y: 100.3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_f_11964_14641",
				width: 60.2,
				height: 67.1,
				x: 182.8,
				y: 42.5,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_f_11964_14641",
				width: 60.2,
				height: 67.1,
				x: 182.8,
				y: 42.5,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_f_11964_14641",
				width: 36.8,
				height: 41.2,
				x: 239.1,
				y: 3,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter7_f_11964_14641",
				width: 34.5,
				height: 39.5,
				x: 239.1,
				y: 4.7,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter8_f_11964_14641",
				width: 57.9,
				height: 69.3,
				x: 269.7,
				y: 6.5,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter9_f_11964_14641",
				width: 57.9,
				height: 69.3,
				x: 269.7,
				y: 6.5,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter10_f_11964_14641",
				width: 28.6,
				height: 31.1,
				x: 325,
				y: 72.8,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter11_f_11964_14641",
				width: 28.6,
				height: 31.1,
				x: 325,
				y: 72.8,
				colorInterpolationFilters: "sRGB",
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						result: "effect1_foregroundBlur_11964_14641",
						stdDeviation: .8
					})
				]
			})
		] })
	]
});
const SvgRedHouse = styled(base)({});
export default SvgRedHouse;
